/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Counts powering the nav indicator: total open todos and the subset that are overdue (deadline in the past). Returned together so the nav makes one request, not two.
 * @export
 * @interface MyTodoCountsResponse
 */
export interface MyTodoCountsResponse {
  /**
   *
   * @type {number}
   * @memberof MyTodoCountsResponse
   */
  openCount: number;
  /**
   *
   * @type {number}
   * @memberof MyTodoCountsResponse
   */
  overdueCount: number;
}

/**
 * Check if a given object implements the MyTodoCountsResponse interface.
 */
export function instanceOfMyTodoCountsResponse(
  value: object,
): value is MyTodoCountsResponse {
  if (!("openCount" in value) || value["openCount"] === undefined) return false;
  if (!("overdueCount" in value) || value["overdueCount"] === undefined)
    return false;
  return true;
}

export function MyTodoCountsResponseFromJSON(json: any): MyTodoCountsResponse {
  return MyTodoCountsResponseFromJSONTyped(json, false);
}

export function MyTodoCountsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MyTodoCountsResponse {
  if (json == null) {
    return json;
  }
  return {
    openCount: json["openCount"],
    overdueCount: json["overdueCount"],
  };
}

export function MyTodoCountsResponseToJSON(json: any): MyTodoCountsResponse {
  return MyTodoCountsResponseToJSONTyped(json, false);
}

export function MyTodoCountsResponseToJSONTyped(
  value?: MyTodoCountsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    openCount: value["openCount"],
    overdueCount: value["overdueCount"],
  };
}
